import { Routes, Route, Navigate } from "react-router";
import { Box } from '@mui/material';
import ClientO365Licenses from "../pages/client/ClientO365Licenses";
import ClientO365Users from "../pages/client/ClientO365Users";
import ClientDevices from "../pages/client/ClientDevices";
import ClientPeople from "../pages/client/ClientPeople";
import ClientDashboardHome from "../pages/client/ClientDashboardHome";
import ClientContracts from "../pages/client/ClientContracts";
import ClientDomains from "../pages/client/ClientDomains";
import ClientSites from "../pages/client/ClientSites";

function MainViewClient({ data }) {
  return (
    <Box display={'flex'} flexDirection={'column'} flexGrow={1}>
        <Routes>
          <Route path="home" element={<ClientDashboardHome />} />
          <Route path="time-analytics" element={<ClientContracts initialTab="analysis" />} />
          <Route path="contracts" element={<ClientContracts />} />
          <Route path="o365" element={<Navigate to="/app/o365/licenses" replace />} />
          <Route path="o365/licenses" element={<ClientO365Licenses />} />
          <Route path="o365/users" element={<ClientO365Users />} />
          <Route path="devices" element={<ClientDevices />} />
          <Route path="sites" element={<ClientSites />} />
          <Route path="domains" element={<ClientDomains />} />
          <Route path="level/devices" element={<Navigate to="/app/devices" replace />} />
          <Route path="eset" element={<Navigate to="/app/devices" replace />} />
          <Route path="eset/devices" element={<Navigate to="/app/devices" replace />} />
          <Route path="staff" element={<ClientPeople />} />
          <Route index element={<Navigate to="home" />} />
        </Routes>
    </Box>
  )
}

export default MainViewClient
